export * from "-!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/stylus-loader/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ItemView.vue?vue&type=style&index=0&id=bea1e2dc&lang=stylus&"


//////////////////
// WEBPACK FOOTER
// ./src/views/ItemView.vue?vue&type=style&index=0&id=bea1e2dc&lang=stylus&
// module id = 618
// module chunks = 3